import z from 'zod'

export const CookieAddressSchema = z.object({
  geo: z.object({
    lat: z.number(),
    lng: z.number(),
  }),
  city: z.object({
    code: z.string(),
    name: z.string(),
    countryCode: z.string(),
  }),
  placeId: z.string(),
  text: z.string(),
  details: z.string(),
  isVerified: z.boolean().optional(),
})

export const DeliveryAddressSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  cityCode: z.string(),
  countryCode: z.string(),
  cityName: z.string(),
  text: z.string(),
  details: z.string(),
  placeId: z.string(),
  isVerified: z.boolean(),
})

export type CookieAddress = z.infer<typeof CookieAddressSchema>
export type DeliveryAddress = z.infer<typeof DeliveryAddressSchema>
